// src/components/ui/workHours.ts — Mon–Fri 09:00–16:00 helper (Europe/London via local time).
export const isWorkHours = (): boolean => {
  const d = new Date();
  const wd = d.getDay();
  const h = d.getHours();
  return wd >= 1 && wd <= 5 && h >= 9 && h < 16;
};
